module.exports = __webpack_public_path__ + "img/E-WEB-Goal-09.ebc62e6e.svg";